import { FACEBOOK_SESSION, USER_FIELDS } from '@mm/api-routes';
import AuthenticatedController from './AuthenticatedController';
import { DEFAULT_HEADERS } from './Controller';

export default class FacebookSessionController extends AuthenticatedController {
  static post(body) {
    return super.post(
      FACEBOOK_SESSION,
      body,
      null,
      DEFAULT_HEADERS,
      null,
      true,
    );
  }

  static async fetchUserAttributes(userId: number) {
    const { userAttributes } = await super.get(USER_FIELDS(userId));

    return userAttributes;
  }
}
